exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".media-library-item-name[data-v-3e3d7efa] {\n  overflow-x: hidden;\n}\n", ""]);

